import { MarketingSquare } from '@/components/marketing-landing/section-label';

export function MarketingCtaLabel({ children }: { children: string }) {
  return (
    <span className="relative inline-flex items-center">
      <MarketingSquare
        size="sm"
        className="bg-marketing-accent-strong absolute left-0 opacity-0 transition-opacity duration-200 ease-out group-hover:opacity-100 group-focus-visible:opacity-100 motion-reduce:transition-none"
      />
      <span className="transition-transform duration-200 ease-out group-hover:translate-x-4 group-focus-visible:translate-x-4 motion-reduce:transition-none">
        {children}
      </span>
    </span>
  );
}
